/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_SelectedInputs */

const en_documents_selected = /** @type {(inputs: Documents_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

/**
* | output |
* | --- |
* | "selected" |
*
* @param {Documents_SelectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const documents_selected = /** @type {((inputs?: Documents_SelectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_SelectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_documents_selected(inputs)
});